import { FC, useEffect, useMemo, useState } from 'react';
import Box from '@mui/material/Box';
import { DataGridProps, GridRowModes, GridToolbar, GridToolbarQuickFilter } from "@mui/x-data-grid";

import { StyledDataGrid } from './DataGrid.styles';
import styled from '@emotion/styled';
import { Checkbox, InputAdornment } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { apiLimit, defaultRowsPerPageOptions } from "../../utils/api.types";


/**
 * Re-usable data grid component.
 */
const BpIcon = styled('span')(({ theme }) => ({
  borderRadius: 3,
  width: 15,
  height: 15,
  boxShadow:
  //   theme.palette.mode === 'dark'
      // ? '0 0 0 1px rgb(16 22 26 / 40%) ' :
      'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
  backgroundColor: 
  // theme.palette.mode === 'dark' ? '#394b59' : 
  '#f5f8fa',
  backgroundImage:
  //   theme.palette.mode === 'dark'
      // ? 'linear-gradient(180deg,hsla(0,0%,100%,.05),hsla(0,0%,100%,0))' :
      'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
  '.Mui-focusVisible &': {
    outline: '2px auto rgba(19,124,189,.6)',
    outlineOffset: 2,
  },
  'input:hover ~ &': {
    backgroundColor: 
  //   theme.palette.mode === 'dark' ? '#30404d' : 
    '#ebf1f5',
  },
  'input:disabled ~ &': {
    boxShadow: 'none',
    background:
      // theme.palette.mode === 'dark' ? 'rgba(57,75,89,.5)' : 
      'rgba(206,217,224,.5)',
  },
}));

const BpCheckedIcon = styled(BpIcon)({
  backgroundColor: '#137cbd',
  backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
  '&:before': {
    display: 'block',
    width: 15,
    height: 15,
    backgroundImage:
      "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
      " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
      "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
    content: '""',
  },
  'input:hover ~ &': {
    backgroundColor: '#106ba3',
  },
});

function QuickSearchToolbar() {
  return (
    <Box
      sx={{
        p: 0.5,
        pb: 0,
      }}
    >
      <GridToolbarQuickFilter className='c-text-field-3' 
                        variant="standard" 
                        style={{width:300}}
                        size='small'
                        InputProps={{
                        disableUnderline: true,
                        startAdornment: <InputAdornment position="start"><SearchIcon style={{marginRight:-5}}/></InputAdornment>,
                        style:{
                          fontSize:14,
                          fontWeight: 'normal'
                        },
                        }}/>
    </Box>
  );
}

interface CustomDataGridProps {
  columns: any;
  rows: any[];
  type: string;
  loading: boolean | undefined;
  checkboxSelection: boolean | undefined;
}

const DataGrid: FC<DataGridProps> = ({ columns, rows, getRowId, loading, checkboxSelection, onSelectionModelChange, isRowSelectable, disableSelectionOnClick, rowCount, page, pageSize, onPageSizeChange, onPageChange, rowsPerPageOptions, selectionModel, components }) => {
  // const [page, setPage] = useState(0); // Current page (0-based index)
  // const [pageSize, setPageSize] = useState(10); // Rows per page

  // // Handle page change
  // const handlePageChange = (newPage: number) => {
  //   page = newPage;
  //   // setPage(newPage);
  //   console.log(newPage);
  // };

  // // Handle page size change
  // const handlePageSizeChange = (newPageSize: number) => {
  //   pageSize = newPageSize
  //   // setPageSize(newPageSize);
  //   console.log(newPageSize);
  // };

  

  return (
    <>
      <StyledDataGrid
        pagination
        paginationMode="server"
        rowsPerPageOptions={rowsPerPageOptions || defaultRowsPerPageOptions}
        pageSize={pageSize || apiLimit.limit}
        page={page || 0}
        onPageSizeChange={onPageSizeChange || undefined}
        onPageChange={onPageChange || undefined}
        rowCount={rowCount || 0}
        rowHeight={52}
        showCellRightBorder
        // showColumnRightBorder
        disableSelectionOnClick={disableSelectionOnClick}
        isRowSelectable={isRowSelectable}
        onSelectionModelChange={onSelectionModelChange}
        selectionModel={selectionModel}
        columns={columns}
        rows={rows}
        getRowId={getRowId}
        loading={loading}
        checkboxSelection={checkboxSelection}
        components={{
          // Toolbar: QuickSearchToolbar,
          BaseCheckbox: (props) => (
            <Checkbox {...props}
                      sx={{
                          '&:hover': { bgcolor: 'transparent' },
                      }}
                      disableRipple
                      checkedIcon={<BpCheckedIcon />}
                      icon={<BpIcon />}
                  />
          ),
          ...(components || {}),
         }}
        // componentsProps={{
        //   toolbar: {
        //     showQuickFilter: true,
        //     quickFilterProps: { debounceMs: 200 },
        //   },
        // }}
      />
    </>
  );
}

export default DataGrid;